import type { PaginatedData } from '../types';
import type { User } from '../user-service/types';


export enum GiftStatus {
  NEW = 'NEW',
  GIFT_REDEEMED = 'GIFT REDEEMED',
}


export interface Gift {
  id: number;
  giftId: number;
  UserId?: number;
  UserCognitoId?: string;
  name: string;
  receiverName: string;
  givername: string;
  giverEmail: string;
  receiverEmail: string;
  giftMessage: string;
  orderDate: string;
  shopifyId: string;
  shopifyGraphQLId: string;
  productSlugs: Array<string>;
  cancelled: boolean;
  giftCode: string;
  createdAt: string;
  updatedAt: string;
  user: User;
  status: GiftStatus;
}

export interface GiftList extends PaginatedData {
  items: Gift[];
}
